export enum EInvoiceType {
    BIWEEKLY = 1,
    MONTHLY = 2
}
